import { useSelector } from "react-redux";

/**
 * True when the logged-in company's plan includes the given feature flag.
 * Feature flags live on the package the /company/details payload stores in
 * redux (state.global.companyDetails.package.features — a map of booleans).
 * Returns false when the flag is missing/unknown (fail-closed for gating).
 */
export function useHasFeature(key) {
  return (
    useSelector((s) => s.global?.companyDetails)?.package?.features?.[key] ===
    true
  );
}
